import {useRef, useState} from 'react'
// import default react-pdf entry
import {Document, Page, pdfjs} from 'react-pdf'
import Loading from '@components/Loading'
import range from 'lodash/range'

// import pdf worker as a url, see `next.config.js` and `pdf-worker.js`
import workerSrc from './pdf-worker'

import styles from './styles.module.css'

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc

export default function PDFViewer({file}) {
  const [numPages, setNumPages] = useState(null)

  function onDocumentLoadSuccess({numPages: nextNumPages}) {
    setNumPages(nextNumPages)
  }
  const containerRef = useRef(null)

  return (
    <>
      <div ref={containerRef}></div>
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div className={styles.loading}>
            <br />
            <br />
            <br />
            <Loading />
            <br />
            <br />
            <br />
          </div>
        }>
        {numPages ? (
          range(numPages).map(page => {
            return (
              <Page
                key={page}
                pageNumber={page + 1}
                externalLinkTarget="_blank"
                width={containerRef.current.offsetWidth || 500}
              />
            )
          })
        ) : (
          <div>Cargando...</div>
        )}
      </Document>
    </>
  )
}
